import gql from "graphql-tag";

const queryGetAllEmployee = gql`
  query(
    $limit: Int
    $page: Int
    $query: String
    $gender: String
    $positionId: ID
    $departmentIds: [ID!]
    $startedDate: CommonDateRangeRequiredFilterInput
  ) {
    getAllEmployee(
      paging: { limit: $limit, page: $page }

      query: $query

      filter: {
        gender: $gender
        positionId: $positionId
        departmentIds: $departmentIds
        startedDate: $startedDate
      }
    ) {
      id
      code
      costCenter
      codeDepartment
      email
      fullname
      startedDate
      birthday
      gender
      phone
      concurrentPositions {
        id
      }
      position {
        id
        name
      }
      department {
        id
        name
      }

      user {
        id
        fullname
        email
      }
      annualLeaveDay {
        id
        remain
        default
        usedInYear
        original
      }
      branchLocation {
        id
        name
        mainShift {
          id
          title
          dayInWeeks
          startTime
          endTime
          startBreakTime
          endBreakTime
          code
          duration
        }
      }
      workShift {
        id
        title
        dayInWeeks
        startTime
        endTime
        startBreakTime
        endBreakTime
        code
        duration
      }
    }
  }
`;

const queryGetUpdateEmployee = gql`
  query($id: ID!) {
    getEmployee(id: $id) {
      id
      code
      email
      fullname
      birthday
      startedDate
      positionId
      departmentId
      userId
      gender
      phone
      concurrentPositions {
        id
      }
      position {
        id
        name
        status
      }
      department {
        id
        name
        status
      }
      branchLocation {
        id
        name
        mainShift {
          id
          title
          dayInWeeks
          startTime
          endTime
          startBreakTime
          endBreakTime
          code
          duration
        }
      }
      branchLocationId
      user {
        id
        fullname
        username
        email
        directManagerId
        directManager {
          id
          employeeId
          username
          email
          fullname
        }
        createdAt
        updatedAt
      }
      annualLeaveDay {
        id
        remain
        default
        usedInYear
        original
      }
      sickLeaveDay {
        id
        remain
        default
      }
      workShiftId
      workShift {
        id
        title
        dayInWeeks
        startTime
        endTime
        startBreakTime
        endBreakTime
        code
        duration
      }
      createdAt
      updatedAt
      author {
        id
        fullname
      }
      costCenter
      codeDepartment
    }
  }
`;

const queryGetAllUser = gql`
  query {
    users(hasEmployee: false) {
      id
      fullname
    }
  }
`;

const queryGetAllDepartment = gql`
  query($status: String) {
    getAllDepartment(status: $status) {
      id
      name
      updatedAt
      createdAt
      status
    }
  }
`;

const queryGetAllPosition = gql`
  query($status: String) {
    getAllPosition(status: $status) {
      id
      name
      updatedAt
      createdAt
      status
    }
  }
`;

export default {
  queryGetAllEmployee,
  queryGetUpdateEmployee,
  queryGetAllUser,
  queryGetAllDepartment,
  queryGetAllPosition,
};
